import React from "react";
import { Salad, Utensils, Sparkles, TrendingUp, Dumbbell } from "lucide-react";

const steps = [
  { icon: Salad,      title: "Improves Digestion",         desc: "Ayurvedic herbs help your gut absorb food better." },
  { icon: Utensils,   title: "Increases Appetite",         desc: "You start feeling hungrier at the right times." },
  { icon: Sparkles,   title: "Better Nutrient Absorption", desc: "Your body pulls more from every meal." },
  { icon: TrendingUp, title: "Healthy Weight Gain",        desc: "Steady, natural gain — no crash bulking." },
  { icon: Dumbbell,   title: "Improved Strength & Stamina",desc: "Feel stronger through your workouts and day." },
];

export default function HowItWorks() {
  return (
    <section className="relative bg-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-4xl">
        <div className="mb-10 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">The Process</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            How It <span className="text-fire">Works</span>
          </h2>
        </div>
        <ol className="relative border-l border-[#FF7A00]/30 pl-8 sm:pl-10">
          {steps.map(({ icon: Icon, title, desc }, i) => (
            <li key={title} className="mb-6 last:mb-0 sm:mb-8">
              <span className="absolute -left-[22px] flex h-11 w-11 items-center justify-center rounded-full bg-fire text-black shadow-[0_0_20px_rgba(255,122,0,0.5)] animate-ring">
                <Icon size={18} />
              </span>
              <div className="glass rounded-2xl p-4 sm:p-5">
                <div className="flex items-baseline gap-2">
                  <span className="font-mono text-xs text-[#FFC107]">Step {i + 1}</span>
                </div>
                <div className="mt-1 font-display text-xl leading-tight text-white sm:text-2xl">
                  {title}
                </div>
                <div className="mt-1 text-sm text-neutral-400">{desc}</div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
